import { gql } from "@apollo/client";

const ISSUE_SUPPORT_TEMPLATE_FIELDS = `
  id
  planType
  name
  subject
  body
  description
  acceptsCustomText
  isActive
  createdAt
  updatedAt
`;

export const GET_ISSUE_SUPPORT_TEMPLATES = gql`
  query GetIssueSupportTemplates($name: String, $planType: IssueSupportPlanType, $includeInactive: Boolean = false, $pageSize: Int = 50, $pageNumber: Int = 0) {
    issueSupportTemplates(name: $name, planType: $planType, includeInactive: $includeInactive, pageSize: $pageSize, pageNumber: $pageNumber) {
      count
      pageSize
      pageNumber
      items {
        ${ISSUE_SUPPORT_TEMPLATE_FIELDS}
      }
    }
  }
`;

export const GET_ISSUE_SUPPORT_TEMPLATE_BY_ID = gql`
  query GetIssueSupportTemplate($id: UUID!) {
    issueSupportTemplate(id: $id) {
      ${ISSUE_SUPPORT_TEMPLATE_FIELDS}
    }
  }
`;
